import React, { FunctionComponent, Suspense, lazy, useMemo } from 'react';

import DlnSwap from '@views/Swap/DlnSwap';

import Loader from '@bitcoin-portal/verse-web-components/dist/Loader';

import { NoView } from '@components/NoView';

import { AddressHandler } from '@context/handlers';
import { useTrackedState } from '@context/store';

import { CefiSwapProvider } from '@views/Swap/context/providers/CefiSwapProvider';

import { findProvider, isFeatureFlagEnabled } from '@helpers/index';

import { SpinnerWrapper, StyledContentBlock } from './styled';

const DefiSwap = lazy(() => import('./DefiSwap'));
const CefiSwap = lazy(() => import('./CefiSwap'));

export const SwapWidget: FunctionComponent = () => {
  const { provider: exchangeProvider } = useTrackedState();

  const swapv2Enabled = isFeatureFlagEnabled('swapv2');

  /** GET PROVIDER  */
  const selectedProvider = useMemo(
    () => findProvider(exchangeProvider),
    [exchangeProvider],
  );

  const isDefiProvider = useMemo(
    () => selectedProvider.isDeFi,
    [selectedProvider],
  );

  const swapv2Content = (
    <>{exchangeProvider === 'bitcoincom' ? <DefiSwap /> : <DlnSwap />}</>
  );

  // TODO: remove if we ever enable swap on holesky
  if (exchangeProvider === 'bitcoincom_heth')
    return (
      <StyledContentBlock>
        <NoView
          minWidth="600px"
          title="Swap"
          subtitle=""
          switchProviderMsg="Swap is not currently available on this network. Please change your network via the top right selector."
          switchNetworkMsg=""
          invalidProvider
        />
      </StyledContentBlock>
    );

  return (
    <StyledContentBlock>
      <AddressHandler isDefiProvider={isDefiProvider} />
      <Suspense
        fallback={
          <SpinnerWrapper>
            <Loader />
          </SpinnerWrapper>
        }
      >
        {isDefiProvider ? (
          <>{swapv2Enabled ? swapv2Content : <DefiSwap />}</>
        ) : (
          <CefiSwapProvider>
            <CefiSwap />
          </CefiSwapProvider>
        )}
      </Suspense>
    </StyledContentBlock>
  );
};

export default SwapWidget;
